import {
  CATALOG_AUTHOR_DETAIL_SET_DATA,
  CATALOG_AUTHOR_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  author: null,
  books: null,
  audiobooks: null,
  booksets: null,
  series: null,
  totalBookCount: null,
  totalAudioBookCount: null,
  similarAuthors: null,
  isFollowedByUser: false,
};

export default function authorDetail(state = initialState, action) {
  switch (action.type) {
    case CATALOG_AUTHOR_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_AUTHOR_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
